import api from './api';

export const getDeviceInfos = async (params = {}) => {
  try {
    const response = await api.get('/admin/device-info/', { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch device diagnostics');
  }
};

export const getDeviceInfo = async (deviceId) => {
  try {
    const response = await api.get(`/admin/device-info/${deviceId}/`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch device details');
  }
};
